export const MOBILE_APP_IOS_LINK = 'https://apps.apple.com/us/app/fourthwall-for-creators/id1479668990';
export const MOBILE_APP_ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.fourthwall.android';
export const addSearchParamsToUrl = (url, params) => {
    const newUrl = new URL(url);
    Object.entries(params).forEach(([paramName, paramValue]) => {
        newUrl.searchParams.append(paramName, paramValue);
    });
    return newUrl.toString();
};
